<template>
  <v-container fluid class="pa-4">
    <v-layout row wrap>
      <v-flex cols="12">
        <!-- <div v-if="loading" class="px-3 mt-2 py-2">
          <v-progress-linear
            :indeterminate="true"
            color="success"
          ></v-progress-linear>
        </div> -->

        <!-- Main Card -->
        <v-card v-if="dedicationSale">
          <v-card-title class="text-h5 font-weight-bold">
            <v-icon left color="success">mdi-receipt</v-icon>
            <div>Sale Details # {{ dedicationSale.saleID }}</div>
          </v-card-title>
          <v-card-text class="pt-6">
            <v-layout row wrap>
              <v-flex xs12 md7>
                <v-list two-line class="bg-transparent">
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-account</v-icon>
                    <span class="font-weight-bold mr-2">Name:</span>
                    <div>
                      <span class="text-h6">{{
                        ` ${dedicationSale.name} - ${dedicationSale.nameH}`
                      }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-sale</v-icon>
                    <span class="font-weight-bold mr-2">Item:</span>
                    <div>
                      <router-link
                        target="_blank"
                        :to="{
                          name: 'DedicationItemView',
                          params: { id: dedicationSale.dedicationItemID },
                        }"
                        class="item-link"
                      >
                        #<span dir="ltr">
                          {{ dedicationSale.dedicationItemID }} -
                          <span dir="rtl">{{
                            dedicationSale.itemName || "—"
                          }}</span>
                          -
                          <span dir="rtl">{{ dedicationSale.itemType }}</span> -
                          {{
                            buildingDesc
                              ? buildingDesc
                              : this.dedicationSale.itemBuildingCode
                          }}
                        </span>
                        <v-icon small color="green" class="ml-1"
                          >mdi-open-in-new</v-icon
                        >
                      </router-link>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Offer Price -->
                  <v-list-tile class="px-0">
                    <v-icon color="green" class="mr-4">mdi-currency-usd</v-icon>
                    <span class="font-weight-bold mr-2 ">Offer Price:</span>
                    <div v-if="!editMode">
                      <span class="text-h6 primary--text">{{
                        formatCurrency(dedicationSale.offerPrice)
                      }}</span>
                    </div>
                    <div v-else class="d-flex align-center ml-4">
                      <v-text-field
                        v-model.number="edit.offerPrice"
                        type="number"
                        prefix="$"
                        :rules="[rules.positiveNumber]"
                      ></v-text-field>
                    </div>
                  </v-list-tile>
                  <v-divider></v-divider>

                  <!-- Final Price -->
                  <v-list-tile class="px-0">
                    <v-icon color="green" class="mr-4">mdi-currency-usd</v-icon>
                    <span class="font-weight-bold mr-2">Final Price:</span>
                    <div v-if="!editMode">
                      <span class="text-h6 primary--text">{{
                        formatCurrency(dedicationSale.finalPrice)
                      }}</span>
                    </div>
                    <div v-else class="d-flex align-center ml-4">
                      <v-text-field
                        v-model.number="edit.finalPrice"
                        type="number"
                        prefix="$"
                        :rules="[rules.positiveNumber]"
                      ></v-text-field>
                    </div>
                  </v-list-tile>
                  <v-divider></v-divider>

                  <!-- Status -->
                  <v-list-tile class="px-0">
                    <v-icon
                      :color="
                        dedicationSale.status == 'Completed'
                          ? 'green'
                          : '#ef6c00'
                      "
                      class="mr-4"
                      >mdi-circle</v-icon
                    >
                    <span class="font-weight-bold mr-2">Status:</span>
                    <div v-if="!editMode">
                      <v-chip
                        small
                        dark
                        :color="
                          dedicationSale.status == 'Completed'
                            ? 'green'
                            : '#ef6c00'
                        "
                      >
                        {{ dedicationSale.status }}
                      </v-chip>
                      <v-btn
                        v-if="dedicationSale.status != 'Completed'"
                        small
                        color="green"
                        dark
                        flat
                        @click="completeSale()"
                      >
                        <v-icon>mdi-check-circle-outline</v-icon>
                      </v-btn>
                    </div>
                    <v-select
                      v-else
                      v-model="edit.status"
                      style="max-width: 200px;"
                      :items="['Pending', 'Completed']"
                    ></v-select>
                  </v-list-tile>
                  <v-divider></v-divider>

                  <!-- Is Legacy -->
                  <v-list-tile class="px-0">
                    <v-icon
                      :color="dedicationSale.isLegacy ? 'green' : 'grey'"
                      class="mr-4"
                      >mdi-alpha-l</v-icon
                    >
                    <span class="font-weight-bold mr-2">Is Legacy:</span>
                    <v-chip
                      v-if="!editMode"
                      small
                      :color="dedicationSale.isLegacy ? 'green' : 'grey'"
                      dark
                    >
                      {{ dedicationSale.isLegacy ? "Yes" : "No" }}
                    </v-chip>
                    <v-checkbox
                      v-else
                      v-model="edit.isLegacy"
                      color="primary"
                    ></v-checkbox>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Created By -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4"
                      >mdi-account-details</v-icon
                    >
                    <span class="font-weight-bold mr-2">Created By:</span>
                    <span class="text-h6">{{ dedicationSale.createdBy }} </span
                    >&nbsp;&nbsp;
                    <span class="font-weight-bold mr-2">On:</span>
                    <span class="text-h6"
                      >{{ formatDate(dedicationSale.createdOn) }}
                    </span>
                  </v-list-tile>

                  <v-divider></v-divider>
                </v-list>
              </v-flex>

              <v-flex xs12 md5>
                <h3 class="mb-3 text-h6 font-weight-bold primary--text">
                  <v-icon small left color="primary">mdi-text-box</v-icon>
                  Description
                </h3>
                <div v-if="!editMode">
                  <v-card
                    v-if="dedicationSale.saleDescription"
                    flat
                    class="pa-4"
                    style="background: #f8f9fa; border-left: 4px solid #1976d2; border-radius: 0 8px 8px 0;"
                  >
                    <div
                      class="grey--text text--darken-3 body-1"
                      style="line-height: 1.7; white-space: pre-wrap;"
                    >
                      {{ dedicationSale.saleDescription }}
                    </div>
                  </v-card>

                  <v-card
                    v-else
                    flat
                    class="pa-4 text-center grey--text text--lighten-1"
                    style="background: #f5f5f5; border: 1px dashed #ccc; border-radius: 8px;"
                  >
                    <v-icon small color="grey lighten-1" class="mb-2"
                      >mdi-information</v-icon
                    >
                    <div class="caption">No description provided.</div>
                  </v-card>
                </div>
                <div v-else>
                  <v-textarea
                    label="Edit Description"
                    v-model="edit.saleDescription"
                    type="text"
                  ></v-textarea>
                </div>
              </v-flex>
            </v-layout>
            <v-card-actions class="mr-0 pb-0">
              <v-spacer />
              <div v-if="!editMode">
                <v-btn small color="success" outline @click="editMode = true">
                  <v-icon left>mdi-pencil</v-icon>
                  Update Sale
                </v-btn>
              </div>
              <div v-else>
                <v-btn color="default" dark @click="reset()">
                  Cancel
                </v-btn>
                <v-btn
                  :loading="loading"
                  color="success"
                  @click="editSale"
                  :disabled="
                    this.edit.offerPrice <= 0 || this.edit.finalPrice < 0
                  "
                >
                  <v-icon left>mdi-check</v-icon>
                  Save
                </v-btn>
              </div>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { onMounted } from "vue";
import { formatCurrency } from "../../utils/helpers.js";
import { getBuildingDetails } from "./DediProHelpers.js";

export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      editMode: false,
      dedicationSale: this.initialData.dedicationSale || {},
      attachments: this.initialData.attachments || [],
      buildings: this.initialData.buildings || [],
      buildingDesc: "",
      edit: {
        offerPrice: null,
        finalPrice: null,
        status: "",
        isLegacy: "",
        saleDescription: "",
      },
      rules: {
        required: (value) => !!value || "Required.",
        positiveNumber: (v) => v >= 0 || "Price must be positive",
      },
    };
  },

  async created() {
    // console.log(this.initialData.buildings)
    const building = await this.getBuildingDetails(
      this.dedicationSale.itemBuildingCode
    );
    building ? (this.buildingDesc = building.description) : "";
    this.edit = {
      offerPrice: this.dedicationSale.offerPrice,
      finalPrice: this.dedicationSale.finalPrice,
      status: this.dedicationSale.status,
      isLegacy: this.dedicationSale.isLegacy,
      saleDescription: this.dedicationSale.saleDescription,
    };
  },

  methods: {
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString() : "—";
    },

    formatCurrency(v) {
      return formatCurrency(v);
    },

    async getBuildingDetails(siteCode) {
      try {
        const building = this.buildings.find((b) => b.code == siteCode);
        if (building.description.split("")[1] === " ") {
          building.description =
            building.description.slice(0, 1) + building.description.slice(2);
        }
        return building;
      } catch (error) {}
    },

    async editSale() {
      if (this.edit.offerPrice <= 0 || this.edit.offerPrice < 0) {
        return;
      }
      this.loading = true;
      const payload = {
        ...this.edit,
        SaleId: this.dedicationSale.saleID,
        PersonID: this.dedicationSale.personID,
        DedicationItemID: this.dedicationSale.dedicationItemID,
      };
      try {
        const response = await this.$http.put(
          "api/dedications/UpdateDedicationSale",
          payload
        );
        this.dedicationSale.offerPrice = response.offerPrice;
        this.dedicationSale.finalPrice = response.finalPrice;
        this.dedicationSale.status = response.status;
        this.dedicationSale.isLegacy = response.isLegacy;
        this.dedicationSale.saleDescription = response.saleDescription;
        this.reset();
      } catch {
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.editMode = false;
      this.edit = {
        offerPrice: this.dedicationSale.offerPrice,
        finalPrice: this.dedicationSale.finalPrice,
        status: this.dedicationSale.status,
        isLegacy: this.dedicationSale.isLegacy,
        saleDescription: this.dedicationSale.saleDescription,
      };
    },
    completeSale() {
      const _confirm = confirm(
        "Are you sure you want to mark this sale as completed?"
      );
      if (_confirm) {
        (this.edit.status = "Completed"), this.editSale();
      }
    },
  },
};
</script>

<style scoped>
.v-card-title {
  word-break: break-word;
}
</style>
